<template>
  <span class="inline-block relative">
    <img
      v-if="user.cognitoInfo.picture"
      class="inline-block rounded-full"
      :class="avatarSize"
      :src="user.cognitoInfo.picture"
      alt=""
      referrerpolicy="no-referrer"
    />
    <span
      v-else
      class="inline-block rounded-full overflow-hidden bg-gray-300"
      :class="avatarSize"
    >
      <icon set="solid" name="user" viewBox="1 0 18 18" class="text-white"/>
    </span>
    <span
      v-if="notifications.length > 0"
      class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full text-white shadow-solid bg-orange-400"
    ></span>
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Avatar",
  props: {
    size: {
      type: [String, Number],
      default: 9
    }
  },
  computed: {
    avatarSize() {
      return `h-${this.size} w-${this.size}`;
    },
    ...mapState(["user", "notifications"])
  }
};
</script>

<style scoped></style>
